/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { type NextApiRequest } from 'next';
import { type ContentStackBlogMenuNavigation } from '../../interface';
import { type FormattedContentStackBlogMenuNavigation } from '../../interface/models';
import { getContentByContentType } from '../common/getContentByContentType';
import { type PageContextType } from '@/next-types';
import { type ParsedUrlQuery } from 'querystring';

export const getContentStackBlogMenuNavigationContent = async (
  req: NextApiRequest | PageContextType['req'],
  query: ParsedUrlQuery,
): Promise<FormattedContentStackBlogMenuNavigation> => {
  const response = await getContentByContentType<ContentStackBlogMenuNavigation>({
    contentTypeUid: 'blog_menu_navigation',
    referenceFieldPath: [],
    req,
    query,
  });

  const { menu_navigation, social_share_tooltip } = response;

  return {
    menu_navigation,
    social_share_tooltip,
  };
};
